import { actionTypes, phoneCodeType } from "./entitiesTypes";

const initialState: entitiesStateType = {
  countryCodes: []
};

type entitiesStateType = {
  countryCodes: Array<phoneCodeType>
};




const entitiesReducer = (
  state = initialState,
  { type, payload }: any
) => {
  switch (type) {
    case actionTypes.SET_COUNTRY_CODES:
      return {
        ...state,
        countryCodes: payload
      }
    default:
      return state;
  }
};

export default entitiesReducer;
